/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import EventDispatcher = alm.event.EventDispatcher;

	export class ColorMap extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super();

			this.isLoading = false;
			this.isLoaded = false;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public load(imageUrl:string, imageWidth:number, imageHeight:number):void {
			if (this.isLoading || this.isLoaded) return;
			this.isLoading = true;

			this.imageUrl = imageUrl;
			this.imageWidth = imageWidth;
			this.imageHeight = imageHeight;

			this.image = new Image();
			this.image.onload = this.imageLoadHandler;
			this.image.src = this.imageUrl;
		}

		private imageLoadHandler = ():void => {
			this.setupImageData();
		};

		public set(image:HTMLImageElement, imageWidth:number, imageHeight:number):void {
			this.image = image;
			this.imageWidth = imageWidth;
			this.imageHeight = imageHeight;

			this.setupImageData();
		}

		private setupImageData():void {
			this.isLoading = false;
			this.isLoaded = true;

			const canvas = document.createElement('canvas');
			canvas.width = this.imageWidth;
			canvas.height = this.imageHeight;

			const context = canvas.getContext('2d');
			context.drawImage(this.image, 0, 0, this.imageWidth, this.imageHeight);

			this.imageData = context.getImageData(0, 0, this.imageWidth, this.imageHeight);
		}

		public getColor(ratio:number):{ r:number, g:number, b:number } {
			const index = Math.floor((this.imageWidth - 1) * ratio) * 4;
			const r:number = this.imageData.data[index];
			const g:number = this.imageData.data[index + 1];
			const b:number = this.imageData.data[index + 2];
			return { r: r, g: g, b: b };
		}

		public getColor2(ratioX:number, ratioY:number):{ r:number, g:number, b:number } {
			const index = (this.imageWidth * 4) * Math.floor((this.imageHeight - 1) * ratioY) + Math.floor((this.imageWidth - 1) * ratioX) * 4;
			const r:number = this.imageData.data[index];
			const g:number = this.imageData.data[index + 1];
			const b:number = this.imageData.data[index + 2];
			return { r: r, g: g, b: b };
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isLoading:boolean;
		private isLoaded:boolean;

		private image:HTMLImageElement;
		private imageUrl:string;
		private imageWidth:number;
		private imageHeight:number;
		private imageData:ImageData;
	}
}
